var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"com-switch-auto-tips"},[_c('el-checkbox',{attrs:{"value":!_vm.autoPopOpTemplate},on:{"change":_vm.handleChange}},[_vm._v(_vm._s(_vm.$t("v270.dont-prompt-again")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }